import { render, staticRenderFns } from "./CmgProgressBar.vue?vue&type=template&id=1c79fba4&scoped=true&lang=pug"
import script from "./cmg-progress-bar.ts?vue&type=script&lang=ts&external"
export * from "./cmg-progress-bar.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgProgressBar.vue?vue&type=style&index=0&id=1c79fba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c79fba4",
  null
  
)

export default component.exports